<template>
    <div
        @dragover="handleDragover"
        @drop.stop.prevent="handleDrop"
        @dragleave="handleDragLeave"
    >
        <slot :hovered="hovered" />
    </div>
</template>
<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const hovered = ref(false);
        const addFiles = inject('addFiles');
        const handleDrop = (evt) => {
            hovered.value = false;
            if (props.disabled) return;
            const files = Array.from(evt.dataTransfer.items)
                .map((item) => {
                    if (item.kind !== 'file') return null;
                    return item.getAsFile();
                })
                .filter(Boolean);
            addFiles(files);
        };
        const handleDragover = (evt) => {
            // preventDefault even when disabled so the browser never takes the
            // drop itself (navigating to the file); dropEffect signals it.
            evt.preventDefault();
            if (props.disabled) {
                evt.dataTransfer.dropEffect = 'none';
                return;
            }
            hovered.value = true;
        };
        const handleDragLeave = () => {
            hovered.value = false;
        };
        return {
            hovered,
            handleDragover,
            handleDragLeave,
            handleDrop,
        };
    },
};
</script>
